import { useTranslation } from 'localization';

import { Button } from 'components';

const Rejected: React.FC = () => {
  const { t } = useTranslation('component.requests');

  return <Button title={t('rejected')} w="100%" variant="ghost" isDisabled />;
};
export default Rejected;
